export default "__VITE_ASSET__gdzcW7GQ__"